import React from "react";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% { transform: scale(0.95); opacity: 0.7; }
  50% { transform: scale(1.15); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.7; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45); /* fundo esmaecido */
  backdrop-filter: blur(3px); /* desfoca o fundo */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* ficar acima de tudo */
`;

const Box = styled.div`
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 14px;
  text-align: center;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  width: 90%;
  max-width: 350px;
`;

const Ball = styled.div`
  width: 70px;
  height: 70px;
  background-color: #0077cc;
  border-radius: 50%;
  animation: ${pulse} 1.1s infinite ease-in-out;
  margin: 0 auto 1.4rem;
`;

const Message = styled.p`
  font-size: 1.15rem;
  color: #444;
  line-height: 1.5;
`;

export default function LoadingCadastroSimples() {
  return (
    <Overlay>
      <Box>
        <Ball />
        <Message>Estamos registrando suas informações...</Message>
      </Box>
    </Overlay>
  );
}
